"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MainTable.default;
  }
});

var _MainTable = _interopRequireDefault(require("./MainTable"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }